import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_ACCOUNT_DETAIL',
        create: 'MARKET_ACCOUNT_CREATE',
        update: 'MARKET_ACCOUNT_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'admin_account',
        default: '',
        label: this.$t('admin_account'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.admin_account,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "admin_account", $$v);
              }
            }
          });
        }
      }, {
        prop: 'admin_pwd',
        default: '',
        label: this.$t('admin_pwd'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.admin_pwd,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "admin_pwd", $$v);
              }
            }
          });
        }
      }];
    }
  }
};